import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { SubprocesTypes } from '../../entity/subprocessen/types/Subproces'
import type { BijlageTemplate as BijlageTemplateType } from '../types/BijlageTemplate'

import { BijlageTemplate } from './BijlageTemplate'

interface Props {
  templates: BijlageTemplateType[]
}

const headerCells = [
  { id: 'sortOrder', numeric: true, label: 'Volgorde', fixed: 20 },
  { id: 'documentsoort', label: 'Documentsoort' },
  { id: 'planning', label: 'Planning' },
  { id: 'assignedto', label: 'Toegewezen aan' },
  { id: 'vinkjes', label: 'Overige informatie' },
  { id: 'uitzonderingen', label: 'Condities' },
  { id: 'actions', label: 'Acties', fixed: 80 },
]

// projecttemplates per processtatus, subprocestemplates per subprocestype
const groupLabel = (template: BijlageTemplateType) => {
  switch (template.scope) {
    case 'project':
      return template.processtatus
    case 'subproces':
      return `Subproces ${SubprocesTypes[template.subproces]}`
    case 'algemeen':
      return 'Algemeen'
  }
}

// groepen in volgorde van voorkomen, subprocesgroepen altijd onderaan
const groupTemplates = (templates: BijlageTemplateType[]) => {
  const ordered = [
    ...templates.filter((t) => t.scope !== 'subproces'),
    ...templates.filter((t) => t.scope === 'subproces'),
  ]

  return ordered.reduce<Record<string, BijlageTemplateType[]>>(
    (acc, template) => {
      const label = groupLabel(template)
      if (!acc[label]) {
        acc[label] = []
      }
      acc[label].push(template)
      return acc
    },
    {},
  )
}

export const BijlageTemplatesByProcesstap = ({ templates }: Props) => {
  const groupedTemplates = groupTemplates(templates)

  return (
    <Box>
      {Object.keys(groupedTemplates).map((label, index) => {
        return (
          <Accordion defaultExpanded={index === 0} key={label}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>
                {label}

                {groupedTemplates[label].length > 0 && (
                  <Chip
                    component="span"
                    size="small"
                    label={groupedTemplates[label].length}
                    sx={{ marginLeft: 1 }}
                  />
                )}
              </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ padding: 0 }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {headerCells.map((headerCell) => (
                        <TableCell
                          key={headerCell.id}
                          align={headerCell.numeric ? 'right' : 'left'}
                          sx={{ width: headerCell.fixed }}
                        >
                          {headerCell.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {groupedTemplates[label].map((template) => (
                      <BijlageTemplate
                        key={template._id}
                        bijlageTemplate={template}
                        templateSet={templates}
                      />
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        )
      })}
    </Box>
  )
}
